import {ToMatchOptions} from 'Shared/utilities/MapDiscriminatedUnion';
import {AgentRole} from 'Users/models/User/AgentUserType';

export class UnvalidatedVIPUserType {
  public readonly key = 'UnvalidatedVIPUserType';
  public readonly agentRole = AgentRole.VIP;

  constructor(
    public readonly hasAhlAccess: boolean,
    public readonly hasNewYorkAccess: boolean,
    public readonly isExternalAdministrator: boolean
  ) {}
}

export class InvalidVIPUserType {
  public readonly key = 'InvalidVIPUserType';
  public readonly agentRole = AgentRole.VIP;

  constructor(
    public readonly hasAhlAccess: boolean,
    public readonly hasNewYorkAccess: boolean,
    public readonly isExternalAdministrator: boolean
  ) {}
}

export class ValidVIPUserType {
  public static create(hasAhlAccess: boolean, hasNewYorkAccess: boolean, isExternalAdministrator: boolean) {
    return hasAhlAccess || hasNewYorkAccess
      ? new ValidVIPUserType(hasAhlAccess, hasNewYorkAccess, isExternalAdministrator)
      : new InvalidVIPUserType(hasAhlAccess, hasNewYorkAccess, isExternalAdministrator);
  }

  public readonly key = 'ValidVIPUserType';
  public readonly agentRole = AgentRole.VIP;

  private constructor(
    public readonly hasAhlAccess: boolean,
    public readonly hasNewYorkAccess: boolean,
    public readonly isExternalAdministrator: boolean
  ) {}
}

export const DefaultVIPUserType = new UnvalidatedVIPUserType(false, false, false);

export const changeHasAhlAccess = (hasAhlAccess: boolean) => ({
  hasNewYorkAccess,
  isExternalAdministrator,
}: VIPUserType) => ValidVIPUserType.create(hasAhlAccess, hasNewYorkAccess, isExternalAdministrator);
export const changeNewYorkAccess = (hasNewYorkAccess: boolean) => ({
  hasAhlAccess,
  isExternalAdministrator,
}: VIPUserType) => ValidVIPUserType.create(hasAhlAccess, hasNewYorkAccess, isExternalAdministrator);
export const changeIsExternalAdministrator = (isExternalAdministrator: boolean) => ({
  hasAhlAccess,
  hasNewYorkAccess,
}: VIPUserType) => ValidVIPUserType.create(hasAhlAccess, hasNewYorkAccess, isExternalAdministrator);
export type VIPUserType = ValidVIPUserType | InvalidVIPUserType | UnvalidatedVIPUserType;

export type VIPUserTypeOptions<TReturn> = ToMatchOptions<VIPUserType, 'key', TReturn>;

export const matchVIPUserType = <TReturn>(vipUserType: VIPUserType, options: VIPUserTypeOptions<TReturn>): TReturn => {
  switch (vipUserType.key) {
    case 'InvalidVIPUserType':
      return options.InvalidVIPUserType(vipUserType);
    case 'UnvalidatedVIPUserType':
      return options.UnvalidatedVIPUserType(vipUserType);
    case 'ValidVIPUserType':
      return options.ValidVIPUserType(vipUserType);
  }
};
